var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"title":"隐私条款"}}),_c('div',{staticClass:"contianer"},[_c('div',{staticClass:"product_text",domProps:{"innerHTML":_vm._s(_vm.list)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }